import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Form, Input, Toast, Dialog } from 'antd-mobile';
//import classNames from 'classnames';
import '@styles/views/home.less';
//import history from '@tools/history';
import '@styles/components/tryOutDialog.less';


// setTryOutDialog
import { selectTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks';
import AppBannerHome from '@components/app/appBannerHome';
import AppFooter from '@components/app/appFooter';
//import AppNewOne from '@components/app/appNewOne';
import $http from '@/http';
import { AxiosRequestConfig } from 'axios';
/* import { setTryOutDialog } from '@store/appSlice';
import { useAppDispatch } from '@hooks/reduxHooks'; */
//import AppAdvantage from '@components/app/appAdvantage';
//import AppDisplayDesc from '@components/app/appDisplayDesc';
interface RegisterForm {
  'registerForm.phone'?: string;
  'registerForm.name'?: string;
  'registerForm.product'?: string;
  'registerForm.company'?: string;
  'registerForm.email'?: string;
  'registerForm.code'?: string;
}
const Home = () => {
  const dispatch = useAppDispatch();
  const tryOutDialog = useSelector(selectTryOutDialog);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [codeTip, setCodeTip] = useState('获取验证码');
  const [count, setCount] = useState(0);
  const [form] = Form.useForm();

  /*  const comboList = useMemo(
    () => [
      {
        name: '体验版',
        title: '免费体验',
        headerBg: require('@images/home/combo1.png').default,
        headerColor: '#2A2A2A',
        descList: [
          '免费试用15天',
          '10GB高速空间免费试用',
          '分享数量无限制试用',
          '2个转换任务并执行',
          '批量上传/下载文件限制10个',
        ],
        btnText: '立即体验',
      },
      {
        name: '个人版',
        title: '个人版本',
        headerBg: require('@images/home/combo2.png').default,
        headerColor: '#2A2A2A',
        descList: [
          '1个月优惠价18元！',
          '10GB高速空间（支持扩容）',
          '文件分享数量5次',
          '3个转换任务并执行',
          '批量上传/下载文件限制100个',
        ],
        btnText: '立即购买',
      },
      {
        name: '企业版',
        title: '企业版本',
        headerBg: require('@images/home/combo3.png').default,
        headerColor: '#ffffff',
        descList: [
          '420元/月起！',
          '10GB高速空间（支持扩容）',
          '启用项目模块，多人协同使用',
          '企业资源库，内部资源实时共享',
          '分享数量=版本人数×5',
          '5个转换任务并执行',
          '批量上传/下载文件限制1000个',
        ],
        btnText: '立即购买',
      },
    ],
    [],
  ); */

  /*  const [active, setActive] = useState(() => comboList[0]); */

  /*  const comboNameListJSX = comboList.map((item) => {
    return (
      <span
        key={item.name}
        className={classNames({ active: item === active })}
        onClick={() => setActive(item)}
      >
        {item.name}
      </span>
    );
  }); */

  /*  const selectComboJSX = (
    <div className={'select-combo'}>
      <div
        className={'head'}
        style={{ background: `url("${active.headerBg}") no-repeat top left/100% 100%` }}
      >
        <span style={{ color: active.headerColor }}>{active.title}</span>
      </div>

      <div className={'desc'}>
        {active.descList.map((desc) => {
          return (
            <div key={desc}>
              <img src={require('@images/home/check.png').default} alt="" />
              <span>{desc}</span>
            </div>
          );
        })}
      </div>

      <div className={'btn'}>
        <span onClick={() => history.push('/buy')}>{active.btnText}</span>
      </div>
    </div>
  ); */

  /*  const fileFormatList = [
    { name: 'DXF文件', logo: require('@images/fileFormat/DXF.svg').default },
    { name: 'CAD文件', logo: require('@images/fileFormat/CAD.svg').default },
    { name: 'BIM文件', logo: require('@images/fileFormat/BIM.svg').default },
    { name: 'DWG文件', logo: require('@images/fileFormat/DWG.svg').default },
    { name: 'NWD文件', logo: require('@images/fileFormat/NWD.svg').default },
    { name: 'DGN文件', logo: require('@images/fileFormat/DGN.svg').default },
    { name: '其他文件', logo: require('@images/fileFormat/other.svg').default },
    { name: 'FBX文件', logo: require('@images/fileFormat/FBX.svg').default },
    { name: 'SKP文件', logo: require('@images/fileFormat/SKP.svg').default },
    { name: 'RVT文件', logo: require('@images/fileFormat/RVT.svg').default },
    { name: 'IFC文件', logo: require('@images/fileFormat/IFC.svg').default },
    { name: 'OBJ文件', logo: require('@images/fileFormat/OBJ.svg').default },
  ]; */

  /*  const fileFormatListJSX = fileFormatList.map((item) => {
    return (
      <div key={item.name} className={'item'}>
        <img src={item.logo} alt="" />
        <span>{item.name}</span>
      </div>
    );
  }); */

  /*  const fnList = [
    { name: '模型轻量化展示', logo: require('@images/home/fn/01.png').default },
    { name: '多格式管理', logo: require('@images/home/fn/02.png').default },
    { name: '提高系统协同办公效率', logo: require('@images/home/fn/03.png').default },
    { name: '高效沟通与记录', logo: require('@images/home/fn/04.png').default },
    { name: '提高BIM模型价值', logo: require('@images/home/fn/05.png').default },
    { name: '支持多文档查看', logo: require('@images/home/fn/06.png').default },
  ]; */

  /*   const fnListJSX = fnList.map((item) => {
    return (
      <div className={'item fn'} key={item.name}>
        <img src={item.logo} alt="" />
        <span className={'name'}>{item.name}</span>
      </div>
    );
  }); */
  const registerRules: FormRule<RegisterForm> = {
    'registerForm.name': [{ required: true, message: '姓名不能为空' }],
    'registerForm.phone': [
      { required: true, message: '手机号不能为空' },
      { pattern: /^1[3|4|5|7|8][0-9]{9}$/, message: '手机号格式不正确' },
    ],
    'registerForm.email': [{ required: true, message: '请输入正确的邮箱地址' }],
    'registerForm.company': [{ required: true, message: '公司不能为空' }],
    'registerForm.product': [{ required: true, message: '产品不能为空' }],
    'registerForm.code': [{ required: true, message: '验证码不能为空' }],
  };

  /**
   * 获取验证码
   */
  const getCode = () => {
    if (count) return;

    form.validateFields(['registerForm.phone']).then((res) => {
      const phone = res['registerForm.phone'] as string;

      let params: GetSmsCodeParams = {
        phone,
      };

      $http.post('api/Home/getsendMailYM', params).then(() => {
        setCount(60);
        Toast.show({
          icon: 'success',
          content: '验证码发送成功，请注意查收',
          position: 'top',
        });
      });
    });
  };

  // 倒计时
  useEffect(() => {
    if (count) {
      setTimeout(() => {
        setCount((prevState) => prevState - 1);
      }, 1000);
    } else {
    }
  }, [count]);

  // 倒计时提示
  useEffect(() => {
    if (count) {
      setCodeTip(`重新获取 ${count}S`);
    } else {
      setCodeTip('重新获取');
    }
  }, [count]);

  /**
   * 关闭弹窗
   */
  /*  const closeDialog = () => {
    dispatch(setTryOutDialog(false));
  }; */
  /**
   * 申请试用
   */
  const register = (data: RegisterForm) => {
    // data.type = 2;
    setLoading(true);
    let params: {
      [propName: string]: string | number | undefined;
    } = {};

    Object.keys(data).forEach((key) => {
      params[key.split('.')[1]] = data[key as keyof RegisterForm];
    });

    params['type'] = 2;
    //https://formspree.io/f/xzboowre
    var responseMsgVisible: AxiosRequestConfig['responseMsgVisible'] = false;
    $http.post('api/Home/sendMail', params, { responseMsgVisible }).then((res) => {
      if (res.data.code === 1) {
        Toast.show({
          icon: 'success',
          content: '提交成功',
          position: 'top',
        });
      } else {
        Toast.show({
          icon: 'fail',
          content: res.data.msg,
          position: 'top',
        });
      }
    });
  };

  const registerFormJSX = (
    <Form
      form={form}
      footer={
        <Button block type="submit" color="danger" data-id={'postemail'}>
          提交
        </Button>
      }
      onFinish={register}
    >
      <Form.Item name={'registerForm.name'} rules={registerRules['registerForm.name']}>
        <div className={'listflex'}>
          <div className={'text-s'}>姓名：</div>
          <Input placeholder={'请输入姓名'} />
        </div>
      </Form.Item>
      <Form.Item name={'registerForm.phone'} rules={registerRules['registerForm.phone']}>
        <div className={'listflex'}>
          <div className={'text-s'}>手机号：</div>
          <Input placeholder={'请输入手机号'} />
        </div>
      </Form.Item>
      <Form.Item name={'registerForm.code'} rules={registerRules['registerForm.code']}>
        <div className={'listflex'}>
          <div className={'text-s'}>验证码：</div>
          <Input placeholder={'验证码'} className={'inputwidth'} />
          <span
            onClick={getCode}
            className={'flex ac jc f13'}
            style={{
              width: 140,
              background: '#DEE1E7',
              alignSelf: 'stretch',
              borderRadius: 4,
              marginLeft: 10,
              color: count ? '#8B8C90' : '#006fff',
            }}
          >
            {codeTip}
          </span>
        </div>
      </Form.Item>
      <Form.Item name={'registerForm.email'} rules={registerRules['registerForm.email']}>
        <div className={'listflex'}>
          <div className={'text-s'}>邮箱：</div>
          <Input placeholder={'请输入邮箱'} />
        </div>
      </Form.Item>
      <Form.Item name={'registerForm.company'} rules={registerRules['registerForm.company']}>
        <div className={'listflex'}>
          <div className={'text-s'}>公司：</div>
          <Input placeholder={'请输入公司'} />
        </div>
      </Form.Item>
      <Form.Item name={'registerForm.product'} rules={registerRules['registerForm.product']}>
        <div className={'listflex'}>
          <div className={'text-s'}>产品：</div>
          <Input placeholder={'请输入申请试用的产品名称'} />
        </div>
      </Form.Item>
    </Form>
  );

  return (
    <div className={'home-page'}>
      <AppBannerHome />
      <br />
      <div className={'detail-desc'}>
        <div className={'content-title'}>
          <span className={'text'}>近期动态</span>
          {/* <span className={'line'} /> */}
        </div>

        <div
          className={'dynamic'}
          onClick={() => {
            window.location.hash = '/newtwo';
          }}
        >
          <img src={require('@images/common/newtwo.png').default} alt="" />
          {/* <p className={'dynamic-title'}>赋能新基建，开启新未来-方案设计评审云上回忆</p>
          <p className={'dynamic-time'}>2022年5月25日（周三）15:00</p> */}
        </div>
        <div
          className={'dynamic'}
          onClick={() => {
            window.location.hash = '/newthree';
          }}
        >
          <img src={require('@images/common/newthree.png').default} alt="" />
          {/* <p className={'dynamic-title'}>桥梁大师 2022 线上发布会</p>
          <p className={'dynamic-time'}>2022年4月27日（周三）15:00</p> */}
        </div>
        <div
          className={'dynamic'}
          onClick={() => {
            window.location.hash = '/newone';
          }}
        >
          <img src={require('@images/common/newone.png').default} alt="" />
        </div>
      </div>
      <div className={'fn detail-desc'}>
        <div className={'content-title'}>
          <span className={'text'}>解决方案</span>
          {/* <span className={'line'} /> */}
        </div>

        <div className={'content'}>
          <div
            className={'item  item-gl fn'}
            onClick={() =>
              Dialog.alert({
                content: (
                  <img src={require('@images/common/QRcode.png').default} alt="" width={'100%'} />
                ),
                onConfirm: () => {
                  console.log('Confirmed');
                },
              })
            }
          >
            {/* <a href={'https://idurl.cn/pYDZqD'}> */}
            <p className={'item-title'}>公路领域</p>
            <p className={'subtitle'}>Highway field</p>
            {/* </a> */}
          </div>
          <div
            className={'item item-tl fn'}
            onClick={() =>
              Dialog.alert({
                content: (
                  <img src={require('@images/common/QRcode.png').default} alt="" width={'100%'} />
                ),
                onConfirm: () => {
                  console.log('Confirmed');
                },
              })
            }
          >
            {/*  <a href={'https://idurl.cn/pYDZqD'}> */}
            <p className={'item-title'}>铁路领域</p>
            <p className={'subtitle'}>Railway field</p>
            {/* </a> */}
          </div>
          <div
            className={'item item-sl fn'}
            onClick={() =>
              Dialog.alert({
                content: (
                  <img src={require('@images/common/QRcode.png').default} alt="" width={'100%'} />
                ),
                onConfirm: () => {
                  console.log('Confirmed');
                },
              })
            }
          >
            {/*  <a href={'https://idurl.cn/pYDZqD'}> */}
            <p className={'item-title'}>水利领域</p>
            <p className={'subtitle'}>Water conservancy field</p>
            {/* </a> */}
          </div>
          <div
            className={'item item-sl fn'}
            onClick={() =>
              Dialog.alert({
                content: (
                  <img src={require('@images/common/QRcode.png').default} alt="" width={'100%'} />
                ),
                onConfirm: () => {
                  console.log('Confirmed');
                },
              })
            }
          >
            {/* <a href={'https://idurl.cn/pYDZqD'}> */}
            <p className={'item-title'}>市政领域</p>
            <p className={'subtitle'}>Municipal sector</p>
            {/* </a> */}
          </div>
        </div>
      </div>

      <div className={'video-play'}>
        <div className={'content-title'}>
          <span className={'text'}>视频展示</span>
          {/* <span className={'line'} /> */}
        </div>

        <div className={'video-cover'}>
          {/* <video src={require('@video/BIMWindows.mp4').default} controls /> */}
          <video
            src={'http://cdn.ksj.com.cn/website/h5/BIMWindows.mp4'}
            poster={'http://ksj.com.cn/images/bimIndex/img/bwImg.png'}
            controls
            webkit-playsinline={'webkit-playsinline'}
          />
        </div>
      </div>

      {/* 核心优势 */}
      {/* <AppAdvantage /> */}

      {/* <AppDisplayDesc /> */}

      {/*  <div className={'combo'}>
        <div className={'content-title'}>
          <span className={'text'}>选购合适您的BIM Windows套餐</span>
          <span className={'line'} />
        </div>
        <div className={'select-name'}>{comboNameListJSX}</div>
        {selectComboJSX}
      </div> */}
      <div className={'on-trial'}>
        <p className={'trialTitle'}>申请试用</p>
        <div className={'trialBg'}>
          <div className={'register'}>{registerFormJSX}</div>
        </div>
      </div>

      <AppFooter />
    </div>
  );
};

export default Home;
/* function setType(arg0: string) {
  throw new Error('Function not implemented.');
} */
